import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../css/Register.css';
import Vas from '../Vas';

import { DateTimeHelper,CheckFields,SetRequired } from 'utils-lib';

import { TextField,DateField,ExtendedButton,MessageBox,Checkbox,Loading, PostCodeCityStreetComponent, EmailRepeatComponent, HoneyPot, SelectField  } from 'component-lib';

import { RequestAjaxClass, AccountsModel, GenderModel } from 'models-lib';


var moment = require('moment');
moment().format();

class Register  extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.AGB='';
        this.state.Daten='';

        this.state.me = this;

        this.ApplicationUrl = Vas.ApplicationUrl;
        this.ApiKey = Vas.ApiKey;
        this.ApiUrl = Vas.ApiUrl;

        this.Request = new RequestAjaxClass((error)=>{ Vas.ErrorHandling(error);},null);
        this.AccountsModel = new AccountsModel([this], null, this.Request);
      
        this.requiredPostCodeCityStreet = true;
        this.requiredEmailRepeat = true;

        this.ConfigDataProtection = Vas.Config.DataProtection;
        this.Config = Vas.Config.RegisterNewCustomer;
        // eslint-disable-next-line no-unused-expressions
        this.Request2 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        this.GenderModel = new GenderModel([this], null, this.Request2);

        this.Request2.setAuth(false);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();

        Vas.clearLocalStorage();

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");
    }
    
    componentDidMount()
    {

        this.Request.setAuth(false);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);

        let reqFields = [this.refs.name, this.refs.firstName, this.refs.dateOfBirth, this.refs.houseNumber];

        let reqCheckBox = [this.refs.AcceptPrivacy,this.refs.AcceptTariffTerms];
        if(this.Config.CheckIban === true){
          reqFields.push(this.refs.iban);
        }

        this.setState({ requiredFields:reqFields,
            requiredCeckBox:reqCheckBox,
            requiredSelectField:[this.refs.Gender] },()=>{
              SetRequired.Set(this.state.requiredFields,this.state.requiredSelectField,this.state.requiredCeckBox,this.refs.PostCodeCityStreet.returnFields(),this.refs.EMailRepeat.returnFields());
            });
    }

    /**
     * updates the state object
     * @constructor
     */
    Update(observer)
    {
      
        this.setState({},()=>{
          if( observer === "AccountCreate"){
            Vas.GetView("RegisterSuccess",null,false);
          }else if(observer === "Gender"){
            let genderSelection = []
        
            if(this.GenderModel.Gender.length > 0){
  
              let genderArray = this.GenderModel.Gender;
  
              if(genderArray.length === 2) {
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
              } else if(genderArray.length === 3){
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
              }
            }
            this.setState({GenderValues : genderSelection});
            this.refs.Gender.setState({Data:genderSelection});
          }
        });
    }

    handleChange = (event, index, value) => {
        this.setState({ value });
    }

    Register(){
        if(this.refs.HoneyPot.isFilled() === false){
          let filled = this.checkFields();
          if (filled === true){
              ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
              this.refs.Register.setState({ usable:false });

              this.AccountsModel.Customer.PostCode = this.refs.PostCodeCityStreet.PostCode;
              this.AccountsModel.Customer.City = this.refs.PostCodeCityStreet.City;
              this.AccountsModel.Customer.Street = this.refs.PostCodeCityStreet.Street == "" ? $("#Street").val() : this.refs.PostCodeCityStreet.Street;

              this.AccountsModel.Customer.Email = this.refs.EMailRepeat.Email;

              this.AccountsModel.AccountCreate("");
          }
        }
    }

    checkFields(){
        
        let filled = false;
        if (this.state.requiredFields && this.state.requiredCeckBox && this.state.requiredSelectField && this.refs.PostCodeCityStreet ){
            
            let postCodeFields = [];
            let emailFields = [];
            if(this.requiredPostCodeCityStreet === true){
              postCodeFields = this.refs.PostCodeCityStreet.returnFields();
            }
            if(this.requiredEmailRepeat === true){
              emailFields = this.refs.EMailRepeat.returnFields();
            }
            
            filled = CheckFields.CheckFields(this.state.requiredFields,this.state.requiredSelectField,this.state.requiredCeckBox,postCodeFields,emailFields);
            
            if(filled[0] === false){
              if(this.requiredEmailRepeat === true){
                if(this.refs.EMailRepeat.returnFilled()[0] === true){
                  if(this.refs.EMailRepeat.state.EmailValid === false){
                    ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Tooltips["Email"]} 
                      Title={Vas.Resources.Titles["Note"]} />
                        ,document.getElementById('messageContainer'));
                  }else{
                    ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Labels["NotAllFields"]} 
                      Title={Vas.Resources.Titles["Note"]} />
                        ,document.getElementById('messageContainer'));
                  }
                }else{
                  ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Labels["NotAllFields"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      ,document.getElementById('messageContainer'));
                }
              }
              else{
                ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["NotAllFields"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  ,document.getElementById('messageContainer'));
              }
              
            }
            return filled[0]
         }       
    }

    AGBClick(){
        document.getElementById("ceckboxAGB").checked=true;
    }

    DatenClick(){
        document.getElementById("checkboxDaten").checked=true;
    }

    setMarketingPhone(marketing){

      let reqFields = this.state.requiredFields;
      if(marketing === true){
        reqFields.push(this.refs.phone);
        this.refs.phone.setState({ Label:this.refs.phone.props.Label+"*" , isrequired : true});
      }else{
        let idx = -1;
        for(let i = 0; i< reqFields.length; i++){
          if(reqFields[i] === this.refs.phone){
            idx = i;
          }
        }
        if(idx > -1){
          reqFields.splice(idx,1);
          this.refs.phone.setState({ Label:this.refs.phone.props.Label , isrequired : false});
        }
      }
      this.setState({requiredFields : reqFields});
    }

    render()
    {
      let iban = <div></div>;
      let ibanHint = <div></div>;
      if(this.Config.CheckIban === true){
        iban =(<TextField
        me={this}
        Editable={true}
        IsRequired={true}
        ref={"iban"}
        Id={"Iban"}
        Label={Vas.Resources.Labels["LastIbanFields"]}
        OnBlur={()=>{ if($("#Iban").val()){
            if($("#Iban").val().length === 4){
              this.AccountsModel.Customer.Iban = $("#Iban").val();
            }else{
              $("#Iban").val('');
              this.AccountsModel.Customer.Iban = $("#Iban").val();
              ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["IbanToShort"]} 
                Title={Vas.Resources.Titles["Note"]}
                Field={"Iban"} />
                  ,document.getElementById('messageContainer'));
            }
          }
        }} />
        );

        ibanHint =<div><b>{Vas.Resources.Titles["Note"]}:</b> {Vas.Resources.Labels["IbanHint"]}</div>;

      }
        return (
          <div className={"RegisterContainer"}>
            <div 
              className={"registerform"} 
              style={{ textAlign:'left' }}>
              <div>
                <h2>{Vas.Resources.Labels["RegisterNewCustomer"]}</h2>

                <div>
                  <p>{Vas.Resources.Labels["RequiredField"]}</p>
                </div>

                <HoneyPot
                  ref={"HoneyPot"}
                  />

                <div className={"Container"}>
                <div className={"ContainerLeft"}>
                    <TextField 
                      Width={182} 
                      Modus={"Name"} 
                      AppURL={Vas.ApplicationUrl} 
                      me={this} 
                      Id={"name"} 
                      ref={"name"} 
                      IsRequired={true} 
                      Editable={true} 
                      name="name" 
                      Label={Vas.Resources.Labels["Name"]} 
                      Tooltip={Vas.Resources.Tooltips["Name"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.Name1 = $("#name").val();}}  />
                  </div>
                  <div className={"ContainerRight"}>
                    <TextField 
                      Width={182} 
                      Modus={"Name"} 
                      AppURL={Vas.ApplicationUrl} 
                      me={this} 
                      Id={"firstname"} 
                      ref={"firstName"} 
                      IsRequired={true} 
                      Editable={true} 
                      name="firstName" 
                      Label={Vas.Resources.Labels["FirstName"]} 
                      Tooltip={Vas.Resources.Tooltips["Firstname"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.Name2 = $("#firstname").val();}}  />
                  </div>
                  
                </div>
                <div className={"Container"}>
                  <div 
                    className={"ContainerLeft"}>
                    <SelectField 
                      AppURL={Vas.ApplicationUrl} 
                      me={this} 
                      ref={"Gender"} 
                      Id={"Gender"}
                      IsRequired={true} 
                      Label={Vas.Resources.Labels["Gender"]} 
                      Data={ this.state.GenderValues } 
                      OnChange={()=>{ this.AccountsModel.Customer.Gender = $("#Gender").val();}} 
                      Tooltip={Vas.Resources.Tooltips["Gender"]} />


                  </div>
                  <div className={"ContainerRight"}>
                    <DateField
                      AppURL={Vas.ApplicationUrl} 
                      MaxValue={moment()} 
                      me={this} 
                      Editable={true} 
                      ref={"dateOfBirth"} 
                      IsRequired={true} 
                      Id={"DateOfBirth"} 
                      Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                      Label={Vas.Resources.Labels["DateOfBirth"]} 
                      OnBlur={()=>{
                        let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
                        this.AccountsModel.Customer.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                      }}  
                      Language={localStorage.getItem("vas_language")} 
                      FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} />
                  </div>
                </div>
                <div className={"Container"} style={{marginTop: '-53px'}}>
                  
                </div>
                <div>
                  <PostCodeCityStreetComponent
                      AppURL={Vas.ApplicationUrl}
                      ApiUrl={Vas.ApiUrl}
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem["vas_token"]}
                      AnonymousToken={localStorage.getItem["anonymous_token"]}
                      TimeOutTime={Vas.TimeOutTime}
                      ref={"PostCodeCityStreet"}
                      Required = {this.requiredPostCodeCityStreet}
                      ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      WidthPostCodeCity = {182}
                      WidthStreet = {390}
                  />
                </div>
                <div className={"Container"}>
                  <div className={"ContainerLeft"}>
                    <TextField 
                      Width={182} 
                      me={this} 
                      Editable={true} 
                      IsRequired={true} 
                      ref={"houseNumber"} 
                      Id={"houseNumber"} 
                      name="houseNumber" 
                      Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                      Label={Vas.Resources.Labels["HouseNumber"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.HouseNumber = $("#houseNumber").val();}} />
                  </div>
                  <div className={"ContainerRight"}>
                    <TextField 
                      Width={182} 
                      me={this}  
                      Id="houseNumberAddition" 
                      Editable={true} 
                      IsRequired={false} 
                      Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                      Label={Vas.Resources.Labels["HouseNumberAddition"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.HouseNumberAddition = $("#houseNumberAddition").val(); }} />
                  </div>
                </div>
                <div className={"Container"}>
                <div className={"ContainerLeft"}>
                    <TextField 
                      Id="addressAddition" 
                      Editable={true} 
                      IsRequired={false} 
                      Tooltip={Vas.Resources.Tooltips["AddressAddition"]} 
                      Label={Vas.Resources.Labels["AddressAddition"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.Name3 = $("#addressAddition").val(); }} 
                      Width={390}/>
                  </div>
                </div>
                <div className={"Container"}>
                <div className={"ContainerLeft"}>
                <EmailRepeatComponent
                  AppURL={Vas.ApplicationUrl}
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  ref={"EMailRepeat"}
                  Required = {this.requiredEmailRepeat}
                  ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  IconId={"EmailRepeatIcon"}/>
                  </div>
                  </div>
                <div className={"Container"}>
                  <div className={"ContainerLeft"}>
                    {iban}
                    
                  </div>
                </div>
                <div className={"Container"}>
                  <div className={"ContainerLeft"}>
                  <br/>{ibanHint}<br/>
                  </div>
                </div>
                <div className={"Container"}>
                  <div className={"ContainerLeft"}>
                    <TextField 
                      Width={182} 
                      me={this} 
                      Id={"phone"} 
                      ref={"phone"}
                      Editable={true} 
                      IsRequired={false} 
                      Tooltip={Vas.Resources.Tooltips["Phone"]} 
                      Label={Vas.Resources.Labels["Phone"]} 
                      OnChange={()=>{ this.AccountsModel.Customer.Phone = $("#phone").val() ; }}
                      Modus={"TelNumber"} />
                  </div>
                </div>
                <br/>

                <div> 
                  <div className={"MarketingComplienceContainer"}><b>{Vas.Resources.Labels["MarketingComplience"]} </b></div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                    <br/>
                    <Checkbox 
                      ref={"MarketingMail"} 
                      Id={"ceckboxMarketingMail"} 
                      onClick={()=>{this.AccountsModel.Customer.MarketingEmail = document.getElementById("ceckboxMarketingMail").checked;}} 
                      IsRequired={true} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingComplienceMail"]} 
                    </label>
                  </div>
                </div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                    <Checkbox 
                      ref={"MarketingPhone"} 
                      Id={"ceckboxMarketingPhone"} 
                      onClick={()=>{
                        this.AccountsModel.Customer.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked;
                        this.setMarketingPhone(document.getElementById("ceckboxMarketingPhone").checked);
                      }} 
                      IsRequired={true} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePhone"]} 
                    </label>
                  </div>
                </div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                    <Checkbox 
                      ref={"MarketingPost"} 
                      Id={"ceckboxMarketingPost"} 
                      onClick={()=>{this.AccountsModel.Customer.MarketingPost = document.getElementById("ceckboxMarketingPost").checked;}} 
                      IsRequired={true} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePost"]} 
                    </label>
                  </div>
                </div>
                </div>        
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                  <Checkbox
                    ref={"AcceptPrivacy"}
                    Id={"checkboxAcceptPrivacy"}
                    onClick={()=>{this.setState({ AcceptPrivacys:$("#acceptPrivacy").val() });}} />
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptPrivacy"]}*</div>
                  </div>
                </div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                  <ExtendedButton 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ViewHere"]} 
                        OnClick={()=>{ window.open(Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf"); }} 
                        Id={"btoAcceptPrivacy"}
                        Width={170} />
                  </div>
                </div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                  <Checkbox
                      ref={"AcceptTariffTerms"}
                      Id={"checkboxAcceptTariffTerms"}
                      onClick={()=>{this.setState({ AcceptTariffTerms:$("#acceptTariffTerms").val() });}} />
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptTariffTerms"]}*</div>
                    
                  </div>
                </div>
                <div className={"ContainerLow"}>
                  <div className={"ContainerLeftCheckBox"}>
                  <ExtendedButton 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ViewHere"]} 
                        OnClick={()=>{ window.open(this.ConfigDataProtection.LinkTarifBestimmungen); }} 
                        Id={"btoAcceptTariffTerms"}
                        Width={170} />
                        <br />
                  </div>
                </div>
                <div className={"RegisterButtonsContainer"}>
                  <div className={"RegisterButton"}>
                    <ExtendedButton
                      Id={"btoRegister"}
                      Width={168}
                      className={"registerButton"} 
                      ref={"Register"} 
                      Usable={true} 
                      Text={Vas.Resources.Labels["Create"]} 
                      OnClick={()=>{ this.Register();}} 
                      style={{ margin: 25 }} />
                  </div>
 
                  <div className={"RegisterButtonCancel"}>
                    <ExtendedButton
                      Id={"btoRegisterCancel"}
                      Width={183}
                      className={"registerButton"} 
                      Usable={true} 
                      Text={Vas.Resources.Labels["Cancel"]} 
                      OnClick={()=>{ Vas.GetView("Home",null, false);}} 
                      style={{ margin: 25 }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
export default Register;
